/* eslint-disable no-underscore-dangle */
const textRefactor = (text, size) => {
  return `${text
    .split(' ')
    .slice(0, size)
    .join(' ')}...`;
};

const chartLinearGradient = (canvas, height, color) => {
  const ctx = canvas.getContext('2d');
  const gradient = ctx.createLinearGradient(0, 0, 0, height);
  gradient.addColorStop(0, `${color.start}`);
  gradient.addColorStop(1, `${color.end}`);
  return gradient;
};

// Custom Tooltip
function customTooltips(tooltip) {
  // Tooltip Element
  let tooltipEl = document.querySelector('.chartjs-tooltip');

  if (!this._chart.canvas.closest('.parentContainer').contains(tooltipEl)) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'chartjs-tooltip';
    tooltipEl.innerHTML = '<table></table>';

    document.querySelectorAll('.parentContainer').forEach(el => {
      if (el.contains(document.querySelector('.chartjs-tooltip'))) {
        document.querySelector('.chartjs-tooltip').remove();
      }
    });

    this._chart.canvas.closest('.parentContainer').appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform');
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign);
  } else {
    tooltipEl.classList.add('no-transform');
  }

  function getBody(bodyItem) {
    return bodyItem.lines;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(getBody);

    let innerHtml = '<thead>';

    titleLines.forEach((title) => {
      innerHtml += `<div class='tooltip-title'>${title}</div>`;
    });
    innerHtml += '</thead><tbody>';

    bodyLines.forEach((body, i) => {
      const colors = tooltip.labelColors[i];
      let style = `background:${colors.backgroundColor}`;
      style += `; border-color:${colors.borderColor}`;
      style += '; border-width: 2px';
      style += '; border-radius: 30px';
      const span = `<span class="chartjs-tooltip-key" style="${style}"></span>`;
      innerHtml += `<tr><td>${span}${body}</td></tr>`;
    });

    innerHtml += '</tbody>';

    const tableRoot = tooltipEl.querySelector('table');
    tableRoot.innerHTML = innerHtml;
  }

  const positionY = this._chart.canvas.offsetTop;
  const positionX = this._chart.canvas.offsetLeft;
  const toolTip = document.querySelector('.chartjs-tooltip');
  const toolTipHeight = toolTip.clientHeight;

  // Display, position, and set styles for font

  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
  tooltipEl.style.top = `${positionY +
    tooltip.caretY -
    (tooltip.caretY > 10 ? (toolTipHeight > 100 ? toolTipHeight + 5 : toolTipHeight + 15) : 70)}px`;
  tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
  tooltipEl.style.fontSize = `${tooltip.bodyFontSize}px`;
  tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
  tooltipEl.style.padding = `${tooltip.yPadding}px ${tooltip.xPadding}px`;
};
// new validations

// name 
export function nameOnChangeValidator(inputValue, maxLength = 25) {
  // allow empty / clearing input
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }
  inputValue = inputValue.replace(/[–—]/g, "-");
  // Allowed characters only
  // const allowedRegex = /^[A-Za-z0-9'$"& -]*$/;
  // if (!allowedRegex.test(inputValue)) {
  //   return "Invalid characters detected";
  // }

  // Max length
  if (inputValue.length > maxLength) {
    return `Input cannot exceed ${maxLength} characters`;
  }

  return null; // ✅ valid
}
// text field
export function validateTextField(inputValue, maxLength = 50) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }
  inputValue = inputValue.replace(/[–—]/g, "-");
  // Only allow letters, numbers, spaces, and common punctuation
  // const allowedRegex = /^[A-Za-z0-9\s.,!?:;\-_*@#'$"%&*()[\]{}]*$/;
  // if (!allowedRegex.test(inputValue)) {
  //   return "Invalid characters detected";
  // }

  if (inputValue.length > maxLength) return `Maximum ${maxLength} characters allowed`;

  return null; // valid
}
// Email field
export function validateEmailField(inputValue, maxLength = 50) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }
  // Regex: only allow specified characters
  const allowedRegex = /^[A-Za-z0-9._%+\-@]+$/;
  if (!allowedRegex.test(inputValue)) {
    return "Invalid email characters detected";
  }

  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

  if (!emailRegex.test(inputValue)) {
    return "Invalid email format.";
  }
  // Check max length
  if (inputValue.length > maxLength) {
    return `Maximum ${maxLength} characters allowed`;
  }

  return null; // valid
}
// mobile/phone/fax
export function mobileOnChangeValidator(inputValue, maxDigits = 20) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }
  // Allowed characters only
  // const allowedRegex = /^[0-9+ ]*$/;
  const allowedRegex = /^[0-9]*$/;
  if (!allowedRegex.test(inputValue)) {
    return "Only numbers are allowed";
  }
  // Max digits (ignore symbols)
  const digitCount = inputValue.replace(/\D/g, "").length;
  if (digitCount > maxDigits) {
    return `Input cannot exceed ${maxDigits} digits`;
  }
  return null; // ✅ valid
}
// Url field
export function validateUrlField(inputValue, maxLength = 2000) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }

  // const allowedRegex = /^[A-Za-z0-9:/?#[@!$&'()*+,;=._~-]+$/;
  // if (!allowedRegex.test(inputValue)) {
  //   return "Invalid URL characters detected";
  // }

  // 3. Format checks
  const fullUrlRegex = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i; // http/https URLs
  const domainRegex = /^(?!-)([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/; // bare domains
  const ipRegex = /^(https?:\/\/)?(\d{1,3}\.){3}\d{1,3}(:\d+)?$/; // IP with optional port

  if (fullUrlRegex.test(inputValue) || domainRegex.test(inputValue) || ipRegex.test(inputValue)) {
    return null; // valid
  }
  if (inputValue.length > maxLength) {
    return `Maximum ${maxLength} characters allowed`;
  }

  return "Invalid URL format.";
}
// LongText field
export function validateDescriptionField(inputValue, maxLength = 2500) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }
  inputValue = inputValue.replace(/[–—]/g, "-");
  // Allowed characters: letters, numbers, spaces, and . , ! ? @ # % & ( ) -
  // const allowedRegex = /^[A-Za-z0-9\s.,:;!?#'$"@%&()\-\s]*$/;
  // if (!allowedRegex.test(inputValue)) {
  //   return "Invalid characters detected";
  // }

  // // Forbidden characters: < > " '
  // const forbiddenChars = /[<>"']/;
  // if (forbiddenChars.test(inputValue)) {
  //   return 'Invalid characters < > " \' detected';
  // }
  // Check max length
  if (inputValue.length > maxLength) {
    return `Maximum ${maxLength} characters allowed`;
  }

  return null; // valid
}
// Address field
export function validateAddressLine(inputValue, maxLength = 50) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }
  inputValue = inputValue.replace(/[–—]/g, "-");
  // 2. Allowed characters only
  // const allowedRegex = /^[A-Za-z0-9 '$&".,:#/-]+$/;
  // if (!allowedRegex.test(inputValue)) {
  //   return "Invalid characters detected";
  // }
  // 1. Check max length
  if (inputValue.length > maxLength) {
    return `Maximum ${maxLength} characters allowed`;
  }

  return null; // valid
}
// Password field
export function validatePassword(inputValue, minLength = 8, maxLength = 50) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }

  const allowedRegex = /^[A-Za-z0-9!@#$%^&*()_+={}[\]-]+$/;
  if (!allowedRegex.test(inputValue)) {
    return "Allowed characters are: A-Z, a-z, 0-9, ! @ # $ % ^ & * ( ) _ + - = { } [ ]";
  }

  if (inputValue.length < minLength) {
    return `Password must be at least ${minLength} characters long`;
  }
  if (inputValue.length > maxLength) {
    return `Password cannot exceed ${maxLength} characters`;
  }


  return null; // valid
}
// Short text field
export function validateShortText(inputValue, maxLength = 50) {
  if (inputValue === undefined || inputValue == null || inputValue === "") return null; // allow empty
  inputValue = inputValue.replace(/[–—]/g, "-");
  // 2. Allowed characters only
  // const allowedRegex = /^[A-Za-z0-9 '$&".,!?-]+$/;
  // if (!allowedRegex.test(inputValue)) {
  //   return "Invalid characters detected";
  // }
  // 1. Check max length
  if (inputValue.length > maxLength) {
    return `Maximum ${maxLength} characters allowed`;
  }

  return null; // valid
}
export function codevalidation(Value, maxLength = 15) {
  if (Value === undefined || Value == null || Value === "") return null; // allow empty
  const allowedRegex = /^[A-Za-z0-9-]+$/;
  if (!allowedRegex.test(Value)) {
    return "Only letters, numbers, and hyphens (-) are allowed";
  }
  if (Value.length > maxLength) {
    return "Purchase number cannot exceed 15 characters";
  }
  return null;
};
export function validateDueDateCount(inputValue, maxLength = 5) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null; // allow empty
  }

  // Only digits allowed
  const numberRegex = /^\d+$/;
  if (!numberRegex.test(inputValue)) {
    return "Only numbers are allowed";
  }

  // Check max length
  if (inputValue.length > maxLength) {
    return `Maximum ${maxLength} digits allowed`;
  }

  return null; // valid
}
export function validateZipCode(inputValue, maxLength = 12) {
  if (!inputValue) return null;
 const value = String(inputValue || "").trim().toUpperCase();

  // Allow letters, numbers, single spaces, and hyphen
  const zipRegex = /^[A-Z0-9]+([ -]?[A-Z0-9]+)*$/;

  if (!zipRegex.test(value)) {
    return "Invalid zip code format";
  }

  if (value.length > maxLength) {
    return `Maximum ${maxLength} characters allowed`;
  }

  return null;
}
export function validateTwilioField(type, inputValue) {
  const patterns = {
    accountSid: /^AC[0-9a-fA-F]{32}$/,
    apiKey: /^SK[0-9a-fA-F]{32}$/,
    apiSecret: /^[A-Za-z0-9_\-=]{32,64}$/,
    appSid: /^AP[0-9a-fA-F]{32}$/,
  };

  const regex = patterns[type];
  if (!regex) {
    return "Unknown Twilio field type"
  }

  if (!regex.test(inputValue)) {
    return `Invalid ${type} format`
  }

  return null;
}
export function apiKeyValidator(inputValue) {
  if (inputValue === undefined || inputValue == null || inputValue === "") {
    return null;
  }

  const regex = /^[A-Za-z0-9_\-=.]+$/;

  if (!regex.test(inputValue)) {
    return "API key can only contain letters, numbers, dashes (-), underscores (_), equals (=), and dots (.)"
  }

  if (inputValue.length < 20 || inputValue.length > 200) {
    return "API key must be between 20 and 200 characters long";
  }

  return null;
};
export { textRefactor, chartLinearGradient, customTooltips };
